export enum StatusFlag {
  New,
  Modified,
  ToRemove,
  Existing,
}
